// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a .product-card[data-v-667e737e]{color:initial}.product-card[data-v-667e737e]{margin:10px}.product-card .title[data-v-667e737e]{width:100%;min-width:100%;max-width:200px;background-color:#eee6c1;text-align:center;font-size:.8em;font-weight:500;line-height:18px;padding-bottom:5px;padding-top:5px}", ""]);
// Exports
module.exports = exports;
